import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ClearIcon from "@mui/icons-material/Clear";
import { Checkbox, FormControlLabel } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import * as CommonStyles from "./CommonStyles";
import "./CommonStyles.scss";

interface ImenuOptions {
  key: number;
  label: string;
}
interface ImenuItem {
  name: string;
  title: string;
  description: string;
  options: any;
  values?: any;
  onChange: any;
  width?: number | string | null | undefined;
  disabled?: boolean;
}

const CheckBoxComponent: FC<ImenuItem> = ({
  name,
  title,
  description,
  options = [],
  values = {},
  onChange,
  disabled = false
}) => {
  const { t } = useTranslation();
  return (
    <Box className="filter-section">
      <h4 style={CommonStyles.titleElement}>{t(title)}</h4>
      <Typography sx={CommonStyles.descriptionElement}>
        {t(description)}
      </Typography>

      {options.map((option: any, index: number) => {
        return (
          <FormControlLabel
            key={`cb-${name}-${option.key}-${index}`}
            style={CommonStyles.inputCheckBox}
            className={`${
              values[option.key] && values[option.key] !== "Indeterminate"
                ? "selected"
                : ""
            }`}
            disabled={disabled}
            control={
              <Checkbox
                color="secondary"
                disabled={disabled}
                checked={
                  values[option.key] && values[option.key] !== "Indeterminate"
                    ? true
                    : false
                }
                icon={
                  <AddCircleOutlineIcon
                    sx={{ color: "var( --primary-color)" }}
                  />
                }
                checkedIcon={<ClearIcon sx={{ color: "#ffffff" }} />}
              />
            }
            label={
              <Typography
                variant="h6"
                component="h6"
                sx={CommonStyles.textElement}
              >
                {option?.label}
              </Typography>
            }
            labelPlacement="start"
            value={option?.key}
            onChange={(e) => {
              if (!disabled) onChange(e, option.key);
            }}
            name={name}
          />
        );
      })}
    </Box>
  );
};

export default CheckBoxComponent;
